<script setup lang="ts">
import monsterUrl from '/assets/monster/glad.png';
import SpeechBubble from '@/components/SpeechBubble.vue';
import MinLivsstilSection from '@/views/slides/MinLivsstil/MinLivsstilSection.vue';
import { computed, inject, ref } from 'vue';
import { useStore } from '@/stores/main';
import { useBackendFetch } from '@/fetch';
import { useIonRouter } from '@ionic/vue';

const store = useStore();
const colorScheme = inject('colorScheme', 'green');
const mainStore = useStore();
const router = useIonRouter();

const sections = ref([]);
const fetchQuestions = async () => {
  const { data, statusCode } = await useBackendFetch('/questions/life')
    .get()
    .json();
  if (statusCode.value === 401) {
    mainStore.logout();
    router.replace('/login');
  } else {
    sections.value = data.value.sections;
  }
};

fetchQuestions();

const backgroundColor = computed(() => {
  return {
    purple: 'bg-purple-background',
    yellow: 'bg-yellow-background',
    green: 'bg-green-background',
    blue: 'bg-blue-background',
  }[colorScheme];
});
</script>

<template>
  <div
    :class="backgroundColor"
    class="flex justify-center w-full md:w-[43%] md:landscape:w-[33%]"
  >
    <div class="relative h-full pt-5">
      <div class="relative flex justify-center top-[8px] mt-10">
        <div class="flex flex-col items-center lg:pb-0 pb-36">
          <MinLivsstilSection
            :sections="sections || []"
            :factors="store.profile?.factors"
          />
        </div>
      </div>
    </div>
  </div>
</template>
